export default __webpack_public_path__ + "static/media/physiological.d9ceea71.jpg";